export default __webpack_public_path__ + "static/media/User_Icon.0fd85fb8.svg";